// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4678":"2f0aa2c3","6430":"012880f4","9010":"a1ab1ba5"}[chunkId] + ".chunk.css";
};